import { api } from 'app/app.api';

import {
  CreatePresignedUrlsApiArg,
  CreatePresignedUrlsApiResponse,
  DeleteAnnouncementApiArg,
  DeleteAnnouncementApiResponse,
  ReadAnnouncementsApiResponse,
  UpdateAnnouncementApiArg,
  UpdateAnnouncementApiResponse,
} from './types/uploadsApi.types';
import { transformReadAnnouncementsResponse } from './utils/transformResponse';

export const uploadsApi = api
  .enhanceEndpoints({
    addTagTypes: ['Announcement'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      createPresignedUrls: builder.mutation<
        CreatePresignedUrlsApiResponse,
        CreatePresignedUrlsApiArg
      >({
        query: ({ type, file, name }) => ({
          version: 1,
          method: 'POST',
          path: `uploads/presigned_url/${type}`,
          body: {
            pretty_name: name || file.name,
            content_type: file.type,
          },
        }),
      }),
      readAnnouncements: builder.query<ReadAnnouncementsApiResponse, void>({
        query: () => ({
          version: 1,
          path: 'uploads/announcement',
        }),
        transformResponse: transformReadAnnouncementsResponse,
        providesTags: ['Announcement'],
      }),
      updateAnnouncement: builder.mutation<
        UpdateAnnouncementApiResponse,
        UpdateAnnouncementApiArg
      >({
        query: ({ file, name }) => ({
          version: 1,
          path: `uploads/announcement/${file}`,
          method: 'PATCH',
          body: {
            pretty_name: name,
          },
        }),
        invalidatesTags: (_result, error) => (error ? [] : ['Announcement']),
      }),
      deleteAnnouncement: builder.mutation<
        DeleteAnnouncementApiResponse,
        DeleteAnnouncementApiArg
      >({
        query: ({ file }) => ({
          version: 1,
          path: `uploads/announcement/${file}`,
          method: 'DELETE',
        }),
        invalidatesTags: (_result, error) => (error ? [] : ['Announcement']),
      }),
    }),
  });
